import { useState, useEffect } from "react";
//--------------------------------------------------------------------------------------------
import UserInfoModal from "src/components/common/userInfoModal";
import Loader from "src/components/common/loader";
import Thumbnail from "src/components/common/thumbnail";
import userimg from "src/img/user.png";
import logoutimg from "src/img/logout.png";
import { myAxios, getBrandLogo } from "src/components/common/functions";
import { clearAccessToken } from "src/components/common/authToken";
import { useMyStore } from "src/components/main/mainStore";
import MainMenu from "./mainMenu";
//--------------------------------------------------------------------------------------------
export default function Main(){
    //--------------------------------------------------------------------------------------------
    const setMainMenuStyle = useMyStore(state => state.setMainMenuStyle);
    const showLoader = useMyStore(state => state.showLoader);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const setAuthenticated = useMyStore(state => state.setAuthenticated);
    const user = useMyStore(state => state.user);
    const [showUserInfo, setShowUserInfo] = useState(false);
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        window.onresize = () => {
            if(window.innerWidth < 960){
                setMainMenuStyle(null);
            }
        }
    },[setMainMenuStyle]);
    //--------------------------------------------------------------------------------------------
    return(
        <>
        <div className = "mainHeader" style = {{background: user.userTheme}}>
            <button type = "button" className = "text-nowrap noButtonStyle" onClick = {() => setShowUserInfo(true)}> 
                <Thumbnail
                    value = {user.thumbnail || userimg}
                    side = {50}
                />
                {user.userName} <span className = "font-weight-bold">V{user.version}</span>
            </button>
            <img className = "cssLogo" src = {getBrandLogo()} alt = ""/>
            <a className = "text-nowrap" href = "./" onClick = {async(e) => {
                e.preventDefault();
                localStorage.setItem("btlKeepLogIn", "false");
                //--------------------------------------------------------------------------------------------
                setShowLoader(true);
                // Revoke this device's refresh family + clear the cookie server-side.
                await myAxios("auth/logout.php", undefined, undefined, undefined, true);
                // Clear client auth state -> PrivateRoute redirects to /Login.
                clearAccessToken();
                setAuthenticated(false);
                setShowLoader(false);
                //--------------------------------------------------------------------------------------------
            }}>
                <img src = {logoutimg} alt = ""/>
                Log out
            </a>
        </div>
        <div className = "mainContent">
            <MainMenu/>
        </div>
        {showUserInfo?
            <UserInfoModal
                user = {user}
                closeIt = {() => setShowUserInfo(false)}
                actionKey = "Save"
                editTheme
                editPhoto
            />
        :null}
        {showLoader?<Loader/>:<></>}
        </>
    )
}